const OPEN_SHOPPING_MUSE_EVENT = 'open-shopping-muse'

export function openShoppingMuse(): void {
  try {
    if (typeof window.DY?.API !== 'function') {
      console.error('Dynamic Yield API is not available')

      return
    }

    window.DY.API('event', {
      name: OPEN_SHOPPING_MUSE_EVENT,
    })
  } catch (error) {
    console.error('Error sending event to Dynamic Yield:', error)
  }
}
